import Vue from 'vue'

/**
 * Le lien d'invitation d'une politique de recharge — un par politique : un lien ne sait pas qui l'ouvre.
 * Ouvert ou fermé, plafond d'utilisations, régénération. policyId absent : la politique par défaut.
 */
class InvitationLinkRepository {

  // GET /api/onboarding/invitation-links/{organizationId} — le lien, ou null
  get(organizationId, policyId = null) {
    return this.fetch({ url: `/api/onboarding/invitation-links/${organizationId}`, method: 'get', data: policyId ? { policyId } : {} })
  }

  // POST /api/onboarding/invitation-links/{organizationId}/regeneration — émettre ou régénérer le lien
  regenerate(organizationId, policyId = null) {
    return this.fetch({ url: `/api/onboarding/invitation-links/${organizationId}/regeneration` + (policyId ? `?policyId=${policyId}` : ''), method: 'post' })
  }

  // PATCH /api/onboarding/invitation-links/{organizationId} — activer / suspendre, plafond (0 = sans plafond)
  update(organizationId, change, policyId = null) {
    return this.fetch({ url: `/api/onboarding/invitation-links/${organizationId}`, method: 'patch', data: { ...change, ...(policyId ? { policyId } : {}) } })
  }

  fetch(options) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch(options)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  }
}

export default new InvitationLinkRepository()
